import { Component, OnInit } from '@angular/core';
import { EMailService } from '../../../services/email.service';
import { EDeliveryService } from '../../../services/edelivery.service';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Observable, Subscription, combineLatest } from 'rxjs';
// import { debounceTime } from 'rxjs/operators';
import { Email } from '../../../models/e-mail.model';
import { Emailresponse } from '../../../models/emailresponse.model';
import { Inject } from '@angular/core';
import { LogService } from '@pershing/pershing-core';
import { FormControl, Validators, FormGroup } from '@angular/forms';
import { EdeliveryLabels } from '../../../i18n/edelivery-labels';
import { PershingTranslationService } from '@pershing/pershing-core';
import { ActivatedRoute } from '@angular/router';
import { DeleteEmailComponent } from '../deleteEmail/deleteEmail.component';
// import { resetFakeAsyncZone } from '@angular/core/testing';

@Component({
  selector: 'updateEmail',
  templateUrl: './updateEmail.component.html',
  styleUrls: ['./updateEmail.component.css']
})
export class UpdateEmailComponent implements OnInit {
  emailResponse: Observable<Emailresponse>;
  private combinedSubscription: Subscription;
  // confirmEmail: string = '';
  errorMessage: string;
  updateEmail1: string = '';
  oldEmail1: Email;
  updateEmail2: string = '';
  updateConfirmEmail1: string = '';
  updateConfirmEmail2: string = '';
  oldEmail2: Email;
  emailToBeSubmitted: Email;
  currentEmails: Email[];
  log: LogService;
  closePopup: boolean = false;
  updateEmailSubscription: Subscription;
  emails: Email[] = [];
  emailSeq1: number = -1;
  emailSeq2: number = -1;
  email1 = new Email(null);
  email2 = new Email(null);
  emailsToBeSubmitted: Email[];
  showDeleteButton1 = false;
  showDeleteButton2 = false;

  // Labels
  updateEmailTitle = EdeliveryLabels.UPDATE_EMAIL_ADDRESS;
  updateEmailMessage1 = EdeliveryLabels.UPDATE_EMAIL_MESSAGE_1;
  updateEmailMessage2 = EdeliveryLabels.UPDATE_EMAIL_MESSAGE_2;
  emailLabel = EdeliveryLabels.EMAIL_LABEL;
  // confirmEmailLabel = EdeliveryLabels.CONFIRM_EMAIL_LABEL;
  invalidEmailAddress = EdeliveryLabels.INVALID_EMAIL;
  invalidEmailAddressMaxLength = EdeliveryLabels.INVALID_EMAIL_MAXLENGTH;
  okLabel = EdeliveryLabels.OK;
  cancelLabel = EdeliveryLabels.CANCEL;
  emailAddress1Label = EdeliveryLabels.EMAIL_ADDRESS1_TITLE;
  confirmEmailAddress1Label = EdeliveryLabels.CONFIRM_EMAIL_ADDRESS1_TITLE;
  emailAddress2Label = EdeliveryLabels.EMAIL_ADDRESS2_TITLE;
  confirmEmailAddress2Label = EdeliveryLabels.CONFIRM_EMAIL_ADDRESS2_TITLE;
  // contactMethodLabel = EdeliveryLabels.CONTACT_METHOD;
  addEmailAddress = EdeliveryLabels.ADD_EMAIL_ADDRESS;
  // contactMethod = 'email';
  deleteLabel: any = EdeliveryLabels.DELETE_LABEL;

  emailForm = new FormGroup({
    'updateEmail1': new FormControl('', [
      Validators.required,
      Validators.email,
      Validators.maxLength(64),
      Validators.pattern('^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$')
    ]),
    'updateConfirmEmail1': new FormControl('', [
      Validators.required,
      Validators.email,
      Validators.maxLength(64),
      Validators.pattern('^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$')
    ]),
    'updateEmail2': new FormControl('', [
      Validators.required,
      Validators.email,
      Validators.maxLength(64),
      Validators.pattern('^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$')
    ]),
    'updateConfirmEmail2': new FormControl('', [
      Validators.required,
      Validators.email,
      Validators.maxLength(64),
      Validators.pattern('^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$')
    ])
  });

  constructor(private emailService: EMailService, private edeliveryService: EDeliveryService,
    public dialog: MatDialog,
              public dialogRef: MatDialogRef<UpdateEmailComponent>, @Inject(MAT_DIALOG_DATA) public data: any, log: LogService,
              private translate: PershingTranslationService,
              private route: ActivatedRoute) {
    this.log = log;
    this.emails = data.emails;
    if (this.translate) {
      this.translate.addTranslationFolder('@pershing/edc-newedelivery', 'node_modules/@pershing/edc-newedelivery/lib');
    }
  }

  ngOnInit() {
    this.emailService.retrieveEmails();
    this.combinedSubscription = combineLatest(this.emailService.emailresponse$, this.route.queryParamMap)
      // .pipe(debounceTime(1000))
      .subscribe(([emailResponse, routeResponse]) => {
        if (emailResponse && routeResponse) {   
          this.showDeleteButton1 = false; 
          this.showDeleteButton2 = false;
          this.oldEmail1 = null;
          this.oldEmail2 = null;
          this.emailForm.get('updateEmail1').setValue('');
          this.emailForm.get('updateConfirmEmail1').setValue('');
          this.emailForm.get('updateEmail2').setValue('');
          this.emailForm.get('updateConfirmEmail2').setValue('');
          this.emails = emailResponse.emails;
          let i = 0;
          for (const email of this.emails) {
            i++;
            if (i === 1) {
              this.oldEmail1 = email;
              this.emailForm.get('updateEmail1').setValue(email.emailAddress);
              this.emailForm.get('updateConfirmEmail1').setValue(email.emailAddress);
              this.updateEmail1 = email.emailAddress;
              this.emailSeq1 = email.emailSeqNum;
              this.showDeleteButton1 = true;
            } else if (i === 2) {
              this.oldEmail2 = email;
              this.emailForm.get('updateEmail2').setValue(email.emailAddress);
              this.emailForm.get('updateConfirmEmail2').setValue(email.emailAddress);
              this.updateEmail2 = email.emailAddress;
              this.emailSeq2 = email.emailSeqNum;
              this.showDeleteButton2 = true;
            }
          }
          // this.showUpdateEmail2 = this.emailService.showUpdateEmail2;
        }
      });
    // this.currentEmails = this.emailService.getUserEmails();
    // console.log('current emails: ', this.currentEmails);
    // this.emailResponse = this.emailService.emailresponse$;
  }

  ngOnDestroy() {
    if (this.updateEmailSubscription) {
        this.updateEmailSubscription.unsubscribe();
    }
  }

  saveEmail(): void {
    this.updateEmail1 = this.emailForm.value.updateEmail1.toUpperCase();
    this.updateConfirmEmail1 = this.emailForm.value.updateConfirmEmail1.toUpperCase();
    this.updateEmail2 = this.emailForm.value.updateEmail2.toUpperCase();
    this.updateConfirmEmail2 = this.emailForm.value.updateConfirmEmail2.toUpperCase();
    console.log('Emails: ', this.updateEmail1, this.updateEmail2);

    if (this.updateEmail1.trim() === '' && this.updateEmail2.trim() === '') {
      this.errorMessage = 'At least one eDelivery Email is required';
      return;
    }

    if (this.updateEmail1 !== undefined && this.updateEmail2 !== undefined) {
      if (this.updateEmail1.trim().toUpperCase() === this.updateEmail2.trim().toUpperCase()) {
        this.errorMessage = 'Only one valid e-mail address is required. If you choose to provide more than' +
                          ' the one required address, each e-mail you enter must be distinct from the previous entry.';
        if (this.translate.translate.store.currentLang === 'es') {
            this.errorMessage = 'Solo se requiere una dirección de correo electrónico válida.' +
            ' Si elige proporcionar más que la dirección requerida,' +
            ' cada correo electrónico que ingrese debe ser diferente de la entrada anterior.';
        }
        return;
      }
   }

   if (this.updateEmail1 !== this.updateConfirmEmail1) {
    this.log.info('Email Address 1 and Confirm Email Address 1 do not match');
    this.errorMessage = 'Email Address 1 and Confirm Email Address 1 do not match';
    if (this.translate.translate.store.currentLang === 'es') {
      this.errorMessage = 'La dirección de correo electrónico ingresada en los dos campos no coincide. Corríjalos.';
    }
    return;
  }

  if (this.updateEmail2 !== this.updateConfirmEmail2) {
    this.log.info('Email Address 2 and Confirm Email Address 2 do not match');
    this.errorMessage = 'Email Address 2 and Confirm Email Address 2 do not match';
    if (this.translate.translate.store.currentLang === 'es') {
      this.errorMessage = 'La dirección de correo electrónico ingresada en los dos campos no coincide. Corríjalos.';
    }
    return;
  }

  //  if ((this.updateEmail1 !== undefined && this.updateEmail1 !== null && this.updateEmail1.trim() !== '') ||
  //     (this.oldEmail1 !== undefined && this.oldEmail1 != null && this.oldEmail1.emailAddress != null && this.oldEmail1.emailAddress.trim() !== '')) {
    if (this.updateEmail1 || this.oldEmail1) {
      this.email1.emailAddress = this.updateEmail1;
      if (this.oldEmail1 !== undefined && this.oldEmail1 !== null) {
        this.email1.oldEmailAddress = this.oldEmail1.emailAddress.trim();
      }
      if (this.emailSeq1 !== -1) {
        this.email1.emailSeqNum = this.emailSeq1;
        this.email1.emailIndex = this.emailSeq1;
      }
      // this.emailsToBeSubmitted.push(this.email1);
    }
    // if ((this.updateEmail2 !== undefined && this.updateEmail2 !== null && this.updateEmail2.trim() !== '') ||
    //   (this.oldEmail2 !== undefined && this.oldEmail2 !== null && this.oldEmail2.emailAddress !== null && this.oldEmail2.emailAddress.trim() !== '')) {
    if (this.updateEmail2 || this.oldEmail2) {
      this.email2.emailAddress = this.updateEmail2;
      if (this.oldEmail2 !== undefined && this.oldEmail2 !== null) {
        this.email2.oldEmailAddress = this.oldEmail2.emailAddress.trim();
      }
      if (this.emailSeq2 !== -1) {
        this.email2.emailSeqNum = this.emailSeq2;
        this.email2.emailIndex = this.emailSeq2;
      }
      // this.emailsToBeSubmitted.push(this.email2);
    }
    this.emailsToBeSubmitted = [this.email1, this.email2];
    this.emailService.updateAllEmails(this.emailsToBeSubmitted);
    // this.resetEmailServiceValues();
    // this.emailService.showEmailPopup = false;
    this.edeliveryService.triggerLoadingIcon(true);
    this.emailService.updateEmailTriggered = true;
    // document.dispatchEvent(new CustomEvent('portal.nxiOneClickAcceptEvent'));
    this.close();    
  }

  // addEmail(): void {
  //   this.emailService.updateEmail1 = this.emailForm.value.updateEmail1.toUpperCase();
  //   this.emailService.updateEmail2 = this.emailForm.value.updateEmail2.toUpperCase();
  //   // this.emailService.showUpdateEmail2 = true;
  //   this.ngOnInit();
  // }

  // resetEmailServiceValues(): void {
  //   this.emailService.updateEmail1 = '';
  //   this.emailService.updateEmail2 = '';
  //   // this.emailService.showUpdateEmail2 = false;
  // }

  deleteEmail(sequence: string): void {
    if (sequence === '1') {
      let email = this.oldEmail1;
      this.dialog.open(DeleteEmailComponent, {data: { email }, panelClass: ['modal', 'edel-DeleteEmail']});
    } else if (sequence === '2') {
      let email = this.oldEmail2;
      this.dialog.open(DeleteEmailComponent, {data: { email }, panelClass: ['modal', 'edel-DeleteEmail']});
    }
  }

  close() {
    // this.resetEmailServiceValues();
    this.dialogRef.close();
  }

}
